import { EventBus, IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeObservable, observable } from 'mobx';

import { StudentClassIdentifier } from '@/application/commons/enums/student-class.enum';
import type { StudentClassesDto } from '@/application/interfaces/pegasus.gateway';
import { Tracking } from '@/application/utils/tracking';
import { SelectClassifierEvent } from '@/presentation/events/select-classifier.event';
import { ClassifiersModel } from '@/presentation/models/classifiers.model';
import { StudentClassesModel } from '@/presentation/models/student-classes.model';
import { StudentClassesStore } from '@/presentation/stores/studentClasses.store';

@ViewModel()
export class PaywallViewModel implements IReactiveModel {
  @observable studentClass: StudentClassesDto;
  @observable isLoading = false;
  @observable paywallType: any;
  @observable hasError: boolean;
  @observable shouldRedirectToLMS: boolean;

  constructor(
    private readonly studentClassesModel: StudentClassesModel,
    private readonly eventBus: EventBus,
    private readonly classifiersModel: ClassifiersModel,
    private readonly studentClassesStore: StudentClassesStore,
  ) {
    makeObservable(this);

    this.eventBus.on(SelectClassifierEvent, () => {
      this.getCurrentStudentClasses();
    });
  }

  @action
  async onInit() {
    Tracking.pageView(this.studentClassesStore.getStudentClassesTrackingInfo());
    this.getCurrentStudentClasses();
  }

  @action.bound
  async getCurrentStudentClasses() {
    try {
      this.isLoading = true;
      this.hasError = false;

      await this.studentClassesModel.getCurrentStudentClasses();

      this.setPaywallData();

      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.hasError = true;
    }
  }

  @action.bound
  async setPaywallData() {
    if (this.classifiersModel.selectedClassifier === null) {
      this.paywallType = StudentClassIdentifier.CurrentStudentClassNotFound;
      return;
    }

    if (!this.studentClassesModel.shouldShowPaywall) {
      this.shouldRedirectToLMS = true;
      this.studentClass = this.studentClassesModel?.currentStudentClass;
      return;
    }

    this.paywallType = this.studentClassesModel.paywallType;
    this.studentClass = this.studentClassesModel?.currentStudentClass;
  }
}
